import axios from "utils/axios";
export const AIHeaders = {
  "Accept-version": "2.0",
  "Cache-Control": "no-cache, private",
};

class AIService {
  chatgptAssist(payload) {
    return axios.post(`ai-service/text-completion`, payload);
  }

	generateAvatar(payload) {
		return axios.post(`ai-service/talking-face`, payload, {
			headers: AIHeaders,
		});
	}

  getGeneratedAvatar(id) {
    return axios.get(`ai-service/talking-face/${id}/status`, {
      headers: AIHeaders,
    });
  }

  getMeetingSummary(data, sOption) {
    if (sOption.ideaId === 2) {
      return axios.post(`ai-service/announcement-gen`, data, {
        headers: AIHeaders,
      });
    }
    return axios.post(`ai-service/bright-ideas`, data, {
      headers: AIHeaders,
    });
    // return {
    //   status: 200,
    //   text: "Content generated successfully",
    //   data: {
    //     text: "Overall summary of discussion:\nThe team had a phone call with a construction company that specializes in building airports. The company has 6000 employees and 250 ongoing projects. The main focus of the meeting was to discuss ideas and generate new ideas from the field. The team has scheduled a demo with the company on August 22 to showcase the new AI capabilities, including the summarizer and avatars. The goal is to impress the company and potentially roll out the technology by the first week of September.\n\nAction items and due dates:\n1. Prepare a demo of the AI capabilities (summarizer and avatars) - Due by August 22. (Team)\n2. Set up a demo environment or dev environment to showcase the capabilities - Due by August 22. (Team)\n3. Launch the technology with the construction company by the first week of September, if they are interested - Due by first week of September. (Team)\n\nTopics to be discussed in the next meeting:\n- Progress on the demo preparation\n- Feedback from the construction company after the demo\n- Implementation plan for rolling out the technology",
    //     response: {
    //       overallSummary: [
    //         "The team had a phone call with a construction company that specializes in building airports. The company has 6000 employees and 250 ongoing projects. The main focus of the meeting was to discuss ideas and generate new ideas from the field. The team has scheduled a demo with the company on August 22 to showcase the new AI capabilities, including the summarizer and avatars. The goal is to impress the company and potentially roll out the technology by the first week of September.",
    //       ],
    //       actionItems: [
    //         "1. Prepare a demo of the AI capabilities (summarizer and avatars) - Due by August 22. (Team)",
    //         "2. Set up a demo environment or dev environment to showcase the capabilities - Due by August 22. (Team)",
    //         "3. Launch the technology with the construction company by the first week of September, if they are interested - Due by first week of September. (Team)",
    //       ],
    //       topicNextMetting: [
    //         "- Progress on the demo preparation",
    //         "- Feedback from the construction company after the demo",
    //         "- Implementation plan for rolling out the technology",
    //       ],
    //     },
    //   },
    // };
  }

	getAvatars() {
		return axios.get("ai-service/avatar", {
			headers: AIHeaders
		});
	}

	getSoundList() {
		return axios.get("ai-service/voice", {
			headers: AIHeaders
		});
	}
}

export default new AIService();
